<script>
  export let loan;
</script>

<style>
  .loan-details div {
    min-width: 150px;
    padding: 0.5em;
  }
</style>

<div class="card mb-4 box-shadow text-center">
  <div class="card-header">
    <h2 class="my-0 font-weight-normal">
      {loan.borrowerName}
      {#if loan.coborrowerName}& {loan.coborrowerName}{/if}
    </h2>
  </div>
  <div class="card-body">
    <div class="row loan-details" style="margin: auto;">
      <div class="col">State: {loan.state}</div>
      <div class="col">Loan Amount: ${loan.loanAmount}</div>
      <div class="col">Interest Rate: {loan.interestRate}%</div>
      <div class="col">Paymet: ${loan.monthlyPayment.toFixed(2)}</div>
      <div class="col">Years: {loan.numberOfYears}</div>
      <div class="col">Est. Closing Date: <br>{loan.closingDate}</div>
    </div>
    <hr />
    <div class="mb-3 text-center row">
      <div class="col-md-4">
        Submitted By
        <ul class="list-unstyled mt-3 mb-4">
          <li>{loan.loName}</li>
          <li>{loan.loEmail}</li>
        </ul>
      </div>
      <div class="col-md-4">
        Borrower
        <ul class="list-unstyled mt-3 mb-4">
          <li>{loan.borrowerName}</li>
          <li>{loan.borrowerPhone}</li>
          {#if loan.borrowerEmail}
            <li>{loan.borrowerEmail}</li>
          {/if}
          <li>Score: {loan.creditScore}</li>
        </ul>
      </div>

      <div class="col-md-4">
        Coborrower
        {#if loan.coborrowerName}
          <ul class="list-unstyled mt-3 mb-4">
            <li>{loan.coborrowerName}</li>
            <li>{loan.coborrowerPhone}</li>
            {#if loan.coborrowerEmail}
              <li>{loan.coborrowerEmail}</li>
            {/if}
            <li>Score: {loan.creditScore}</li>
          </ul>
        {:else}
          <ul class="list-unstyled mt-3 mb-4">
            <li>--</li>
          </ul>
        {/if}
      </div>
    </div>
  </div>
</div>
